import { Root as SwitchRoot, Thumb as SwitchThumb } from "@radix-ui/react-switch";

import { Text } from "@/components/ui/text";

import { useSwitch, UseSwitchProps } from "./use-switch";

export type SwitchProps = UseSwitchProps;

function Switch(props: SwitchProps) {
  const { className, styles, id, label, ...rest } = useSwitch(props);

  return (
    <div className={styles.base({ className })}>
      {label && (
        <Text tag="label" size="bodyMedium" className={styles.label()} htmlFor={id}>
          {label}
        </Text>
      )}
      <SwitchRoot className={styles.root()} id={id} {...rest}>
        <SwitchThumb className={styles.thumb()} />
      </SwitchRoot>
    </div>
  );
}

export default Switch;
